import { cn } from "@/lib/utils";
import { ArrowUpRightIcon } from "@heroicons/react/24/solid";

export const projectItemCn = cn(
  "flex flex-col group cursor-pointer rounded-2xl transition-all shadow-[-76px_209px_62px_0_rgba(0,0,0,0.00),-49px_134px_57px_0_rgba(0,0,0,0.00),-12px_33px_36px_0_rgba(0,0,0,0.01),-3px_8px_20px_0_rgba(0,0,0,0.01)]",
  "dark:shadow-[0_0_0_1px_rgba(0,0,0,0.25)]",
  "bg-gradient-to-b from-[#F5F5F7] to-[#EAEAEC] dark:from-[#36363C] dark:to-[#2C2C30]",
  "dark:hover:from-[#3C3C42] dark:hover:to-[#323236]",
  "p-[0.5px]",
  "max-w-[400px]",
);

type ProjectCardProps = {
  project: {
    id: string;
    name: string | null;
    thumbnailUrl: string | null;
    updatedAt: Date;
  };
  onClick: () => void;
  actions?: React.ReactNode;
};

export function ProjectCard({ project, onClick, actions }: ProjectCardProps) {
  return (
    <div
      key={project.id}
      className={cn(projectItemCn, "hover:shadow-none w-full min-w-0")}
      onClick={onClick}
    >
      <div className="bg-[#ffffff] dark:bg-[#19191C] shadow-xs rounded-2xl h-full flex flex-col relative overflow-hidden">
        <div className="absolute inset-0 bg-[#19191C] dark:bg-white opacity-0 group-hover:opacity-[0.02] dark:group-hover:opacity-[0.01] transition-opacity pointer-events-none z-10"></div>
        {/* Artifact thumbnail */}
        {project.thumbnailUrl ? (
          <div className="aspect-[16/10] overflow-hidden rounded-xl mx-[6px] mt-[6px]">
            <img
              src={project.thumbnailUrl}
              alt={project.name ?? "Project thumbnail"}
              className="size-full object-cover object-top"
            />
          </div>
        ) : (
          <div className="aspect-[16/10] rounded-[10px] bg-[#f3f3f4] dark:bg-[#232325] flex items-center justify-center overflow-hidden mx-[6px] mt-[6px]">
            <div className="grid grid-cols-8 gap-1 p-4">
              {Array.from({ length: 32 }).map((_, i) => (
                <div
                  key={i}
                  className="h-2 w-2 rounded-sm bg-primary/10"
                  style={{
                    opacity: Math.random() * 0.5 + 0.3,
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {/* Project details */}
        <div className="flex items-start justify-between gap-2 min-w-0 pl-4 pr-1 py-3">
          <div className="flex-1 min-w-0">
            <h3 className="font-normal text-foreground truncate">
              {project.name}
            </h3>
          </div>
          {!actions && (
            <div className="px-3.5 h-full flex items-center">
              <ArrowUpRightIcon className="size-3.5" />
            </div>
          )}
          {actions && (
            <div
              className="px-3 flex items-center"
              onClick={(e) => e.stopPropagation()}
            >
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
